require("./wdh-legacy/center-locator/js/base/component-center-locator.js");